<template>
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
               <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#location"
                  aria-controls="location">
                  
                  <span>
                    <img src="../assets/logo.png" style="    width: 200px;">
                  </span>
                  <span class="weather-container">
                    <i class="bi bi-thermometer "></i> {{ current_temperature?(current_temperature).toFixed(1):'' }}
                  </span>
               </a>
         
            </div>
         </div>
         <!--start------------------------------------------------------- body----------------------------------------------------------------------------->

         <!-- Body -->
        <div class="container d-flex flex-column justify-content-center align-items-center flex-grow-1">
            <div class="card p-4 shadow" style="width: 100%; max-width: 400px;">
                <h3 class="text-center mb-3">Login</h3>
                <form @submit.prevent="handleLogin">
                    <div class="mb-3">
                        <label for="username" class="form-label">Mobile No</label>
                        <input type="text" id="username" v-model="username" class="form-control" required>
                    </div>
                    <div class="mb-3">
                        <label for="otp" class="form-label">Otp</label>
                        <input type="number" id="otp" v-model="otp" class="form-control" maxlength="4"required>
                    </div>
                    <button type="submit" class="btn btn-primary w-100 custom-btn">Login</button>
                </form>
                <div class="text-center mt-3">
                    <p>Not registered?<router-link :to="'/register'">Create an account</router-link></p>

                </div>
            </div>
        </div>

        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->










   

         <!-- footer -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>
            </div>
        </div>
      </div>
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.custom-btn {
    background: linear-gradient(328deg, #ff0000, #000199);
    border: none; /* Remove Bootstrap's default border */
    color: white; /* Ensure text is readable */
}

</style>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
    // this.initializeHomeContent();
      var $main_nav = $('#main-nav');
    var $toggle = $('.toggle');
    var defaultOptions = {
        disableAt: false,
        customToggle: $toggle,
        levelSpacing: 40,
        navTitle: 'App',
        levelTitles: true,
        levelTitleAsBack: true,
        pushContent: '#container',
        insertClose: 2
    };
    var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    
    this.fetchWeather();
    this.getHomeBasic(); // Call the method here
},
  data() {
    return {
      loading:false,
      error:null,
      categories:[{name:"Event"},{name:"Food"},{name:"Offers"},{name:"News"},{name:"Properties"},],
      listings:[{name:"DK",business:"Software",offer:"10% Off"},{name:"Shree Computer",business:"Software",offer:"10% Off"},{name:"Corner Crunch",business:"Hotel",offer:"20% Off"}],
      events:[{name:"Hasya jatra",location:"Hutatma",cost:"200 ",time:"6PM "},{name:"Lavanya Khani",location:"Hutatma",cost:"200 ",time:"10PM "},{name:"Cricket",location:"Part Maidan",cost:"200 ",time:"4PM "}],
      properties:[
        {name:"2BHK Near Avanti nagar",area:"2000sqft",persqft:"2000 ",type:"Residendial "},
        {name:"1BHK Near Bajaj nagar",area:"2500sqft",persqft:"5000 ",type:"Commercial "},
        {name:"Open Plot Near Highway",area:"2000sqft",persqft:"2000 ",type:"Residendial "},],
        current_temperature:0,
     


    }
  },
  methods:{
    initializeHomeContent(){
    

    // Coupons
    $('.coupons').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1.3,
        slidesToScroll: 1,
    });

    // Top Picks - Homepage
    $('.top-picks').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 1,
    });

    // All Categories - Homepage
    $('.all-cate').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 4.5,
        slidesToScroll: 3,
    });

    // Product Detail
    $('.product-slider').slick({
        arrows: false,
        autoplay: true,
        infinite: false,
        dots: true,
    });
    // this.getHomeBasic();
    }
,
async fetchWeather() {
      const url =
        "https://api.open-meteo.com/v1/forecast?latitude=17.6599&longitude=75.9064&hourly=apparent_temperature&timezone=auto&forecast_days=1";

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Weather data not available");
        const data = await response.json();
        
        // Get the latest hourly temperature
        if (data.hourly && data.hourly.apparent_temperature.length > 0) {
          this.current_temperature = data.hourly.apparent_temperature[0]; // First hour's temperature
        }
      } catch (error) {
        console.error("Error fetching weather:", error);
      }
    }, 
    async getHomeBasic() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getfrontview").then((response) => {
            self.categories = response.data.app_categories;
            self.events = response.data.events;
            self.listings = response.data.businesslisting;
            self.properties = response.data.properties;
            
            
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 
  }
}
</script>
